module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<div class="m-modal modal-dialog modal-login">\n      <div class="m-modal-content modal-content">\n\n          <div class="m-modal-header">\n              <div class="m-modal-header__title">Smart City Portal<div>.</div></div>\n          </div>\n\n          <div class="m-modal-body">\n\n              <div class="m-modal-section">\n                  <div class="m-modal-row">\n                  			<div class="m-modal-warning">\n													<div class="warning-title">'+
((__t=( warning.title ))==null?'':__t)+
'</div>\n													';
 if (warning.details) { 
__p+='\n													<ul class="warning-list">\n															';
 _.each(warning.details, function(detail) { 
__p+='\n																<li>'+
((__t=( detail ))==null?'':__t)+
'</li>\n															';
 }) 
__p+='\n													</ul>\n                  				';
 } 
__p+='\n                  			</div>\n                       	<div class="form-group">\n                       		<input type="input" class="form-control" name="email" placeholder="Email" value="'+
((__t=( email ))==null?'':__t)+
'">\n                      	</div>\n                      <div class="form-group">\n                          <input type="password" class="form-control" name="password" placeholder="Password" value="'+
((__t=( password ))==null?'':__t)+
'">\n                      </div>\n                  </div>\n              </div>\n\n          </div>\n\n          <div class="m-modal-footer">\n              <div class="m-modal-footer__left"></div>\n              <div class="m-modal-footer__right">\n                  <a class="m-btn m-btn--primary js-submit">Login</a>\n              </div>\n          </div>\n\n      </div>\n  </div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-login/show/templates/layout.html
// module id = 453
// module chunks = 0